import { createSSRApp, createApp } from "vue";
import App from "./App.vue";
// import createRouter from './router';

import { createVfm } from 'vue-final-modal';

// custom permission directive
import permissionDirective from './directives/permission';

import router from "./router/routes";
import store from "./vuex/store";

import common_function from "@/assets/commonjs/common_function";
// import validations from "./assets/commonjs/validation";
// import isBefore from "date-fns/fp/isBefore/index";

const isSSR = typeof window === "undefined";

export default function () {
  // const rootComponent = {
  //   render: () => h(App),
  //   components: { App },
  // };

  router.afterEach(() => {
    console.log("afterEach invoked");
    
    setTimeout(()=> {
       common_function();
    }, 300)
  })

  const app = isSSR ? createSSRApp(App) : createApp(App);

  app.use(store);
  app.use(router);

  const vfm = createVfm()
  app.use(vfm)

  // app.use(common_function);
  // app.use(validations);

  app.directive('permission', permissionDirective);

  return {
    app,
    store,
    router,
      // common_function,
      // validations,
  };
}
